import { BaseApplication } from 'ohzi-core';
import { NormalRender } from 'ohzi-core';
import { Graphics } from 'ohzi-core';
import { ResourceContainer } from 'ohzi-core';
import { ViewManager } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';

import DatGui from './components/DatGui';
import SceneController from './components/SceneController';

import { sRGBEncoding } from 'three';
import { RepeatWrapping } from 'three';
import { ACESFilmicToneMapping } from 'three';
import { Scene } from 'three';
import { PCFSoftShadowMap } from 'three';

import { Sections } from './views/Sections';
import HomeView from './views/HomeView';

import BuildingMaterial from './materials/BuildingMaterial';

export default class MainApplication extends BaseApplication
{
  init()
  {
    
    this.scene_controller = SceneController;
    this.normal_render_mode = new NormalRender();

    this.scene_controller.init();

    Graphics.set_state(this.normal_render_mode);
    Graphics._renderer.outputEncoding = sRGBEncoding;
    Graphics._renderer.toneMapping = ACESFilmicToneMapping;
    //Graphics._renderer.shadowMap.enabled = true;
    Graphics._renderer.shadowMap.type = PCFSoftShadowMap; // default THREE.PCFShadowMap

    this.home_view = new HomeView();
    this.home_view.hide();
    
    SceneManager.ui = new Scene();

    DatGui.init();

  }

  on_enter()
  {

    ResourceContainer.get_resource("grid").wrapS = RepeatWrapping;
    ResourceContainer.get_resource("grid").wrapT = RepeatWrapping;
    ResourceContainer.get_resource("noise").wrapS = RepeatWrapping;
    ResourceContainer.get_resource("noise").wrapT = RepeatWrapping;

    this.config = ResourceContainer.get_resource('config');

    this.sections = Sections;

    this.scene_controller.start();
    this.home_view.start();

    DatGui.start();

    this.go_to(Sections.HOME);

    document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    }, false);

    document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    }, false);
    document.addEventListener('gesturestart', function(e){
      e.preventDefault();
    });
    document.addEventListener('gestureend', function(e){
      e.preventDefault();
    });
  }

  go_to(section)
  {
    ViewManager.go_to_view(section, false);
  }

  update()
  {
    this.scene_controller.update();
  }

  on_post_render() {
    Graphics.clear(undefined, undefined, true, true);
    Graphics.render(SceneManager.ui, CameraManager.current)
  }

  on_post_start()
  {
  }
}
